import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import applyCouponForm from './ApplyCouponForm'
import toggledApplyCouponFrom from './ToggledApplyCouponForm'
import { APPLY_COUPON_FORM } from './constants'
import viewModel from './viewModel'
import { submitApplyCouponForm } from './actions'

const withViewModel = withProps({
  viewModel
})

const extend = compose(
  connect(null, { onSubmit: submitApplyCouponForm }),
  reduxForm({ form: APPLY_COUPON_FORM }),
  withViewModel
)

export default extend(applyCouponForm)

export const ToggledApplyCouponForm = extend(toggledApplyCouponFrom)
